/** Docs (UA): https://prostopay.atlassian.net/wiki/spaces/SW/pages/1903853583 — Знижки */

import { useAppStore } from '../../../../../shared/hooks/useAppStore';
import { useDiscountedPrice } from '../../../hooks';
import { PriceDisplay } from '../PriceDisplay';

export function PriceFromUserInput({
    className,
    amountInSubunits,
    inputAmount,
}: {
    className?: string;
    amountInSubunits: number;
    inputAmount: number;
}) {
    const vm = useAppStore((store) => store.vm);
    const priceView = useDiscountedPrice({
        amountInSubunits,
        inputAmount,
        discountPercentage: vm?.campaign?.discount_percentage,
    });

    return (
        <PriceDisplay
            className={className}
            totalAmount={priceView.discountedAmount}
            originalAmount={priceView.originalAmount}
            savings={priceView.savings}
            currencyCode={vm?.currency_code}
            campaignMessage={vm?.campaign?.message}
            discountPercentage={vm?.campaign?.discount_percentage}
            startHour={vm?.campaign?.start_hour}
            endHour={vm?.campaign?.end_hour}
        />
    );
}
